import classnames from 'classnames';
import noop from 'lodash/noop';
import React from 'react';

import { Icon as LegacyIcon } from '@ant-design/compatible';

import styles from './index.less';

const CollapseTrigger = ({ direction, triggerAction, renderCustomChild, isCollapsed }) => {
  if (renderCustomChild) {
    return renderCustomChild();
  }
  const isVertical = direction === 'vertical';
  const horizontalIconType = isCollapsed ? 'down' : 'up';
  const verticalIconType = isCollapsed ? 'right' : 'left';
  const iconType = isVertical ? verticalIconType : horizontalIconType;

  return (
    <div
      onClick={triggerAction}
      className={classnames(styles.collapseTrigger, {
        [styles.collapseTriggerVertical]: isVertical,
        [styles.collapseTriggerHorizontal]: !isVertical,
      })}
    >
      <LegacyIcon type={iconType} />
    </div>
  );
};

CollapseTrigger.defaultProps = {
  direction: 'vertical',
  isCollapsed: false,
  renderCustomChild: null,
  triggerAction: noop,
};

export default CollapseTrigger;
